import {Button, ButtonGroup, Chips} from 'platform/components';
import {Space, VStack} from 'platform/foundation';

import {useState} from 'react';

import {PurchaseVehicleType} from '@dms/api/finance';
import {EntityResourceIds} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {businessCaseRoutes, testIds, vehiclesRoutes} from '@dms/routes';
import {queryParams} from '@dms/shared';

import {composePath, Nullish, useNavigate} from 'shared/web';

const purchaseVehicleTypeOptions = [
  {
    label: i18n.t`entity.vehicle.labels.typeInStock`,
    value: 'IN_STOCK',
  },
  {
    label: i18n.t`entity.vehicle.labels.typeBrokerage`,
    value: 'BROKERAGE',
  },
];

interface SelectPurchaseFormProps {
  businessCaseId: string;
}

export function SelectPurchaseForm(props: SelectPurchaseFormProps) {
  const navigate = useNavigate();
  const [purchaseVehicleType, setPurchaseVehicleType] = useState<PurchaseVehicleType>('IN_STOCK');

  const onAddVehicleToBuy = () => {
    const returnUrl = composePath(businessCaseRoutes.buying, {
      params: {id: props.businessCaseId},
    });

    navigate(
      composePath(vehiclesRoutes.createV2, {
        queryParams: {
          [queryParams.RETURN_URL]: returnUrl,
          [queryParams.VEHICLE_PURCHASE_TYPE]: purchaseVehicleType,
          [queryParams.REDIRECT_SOURCE]: EntityResourceIds.businessCase,
          id: props.businessCaseId,
        },
      })
    );
  };

  const onChangePurchaseVehicleType = (purchaseVehicleType: string[] | Nullish) => {
    setPurchaseVehicleType(purchaseVehicleType?.[0] as PurchaseVehicleType);
  };

  const closeAndResetState = () => {
    setPurchaseVehicleType('IN_STOCK');
  };

  return (
    <VStack>
      <Chips
        label={i18n.t('page.businessCase.labels.selectPurchaseVehicleType')}
        data-testid={testIds.businessCase.detail('purchaseVehicleType')}
        onChange={onChangePurchaseVehicleType}
        value={[purchaseVehicleType as string]}
        options={purchaseVehicleTypeOptions}
      />

      <Space vertical={4} />
      <ButtonGroup
        align="right"
        data-testid={testIds.businessCase.detail('purchaseVehicleType-actions')}
      >
        <Button
          data-testid={testIds.businessCase.detail('purchaseVehicleType-actions-discard')}
          variant="secondary"
          onClick={closeAndResetState}
          title={i18n.t('general.actions.cancel')}
        />
        <Button
          data-testid={testIds.businessCase.detail('purchaseVehicleType-actions-confirm')}
          variant="primary"
          onClick={onAddVehicleToBuy}
          title={i18n.t('general.actions.confirm')}
        />
      </ButtonGroup>
    </VStack>
  );
}
